export default __webpack_public_path__ + "b8e494da1ec1f18247698e8a401a3f0b.woff2";